var imported = document.createElement('script');
var generic = generic || {};
var presentAfterpay = presentAfterpay || {};
var priceSelector = '.price_installment';
var locale = generic.cookie('LOCALE');
var min = 3500;
var max = 100000;
var apConfig = apConfig || {};

if (Drupal.settings.globals_variables.display_installment_price) {
  var userAgent = window.navigator.userAgent;
  var isIE = userAgent.indexOf('MSIE ') > 0 || !!userAgent.match(/Trident.*rv\:11\./);

  if (isIE) {
    imported.src = '/sites/aveda/themes/aveda_base/template_api/products/product_sku_price_v1/present-afterpay.js';
  } else {
    imported.src = 'https://static-us.afterpay.com/javascript/present-afterpay.js';
  }

  document.head.appendChild(imported);
}

$(window).load(function () {
  if (!$('.js-afterpay').length) {
    return;
  }
  var amount = null;

  presentAfterpay.afterpayConfig = function (amount) {
    var currency = window.utag_data ? window.utag_data.currency_code : 'USD';

    $('.afterpay-paragraph').length ? $('.afterpay-paragraph').remove() : '';
    apConfig = {
      priceSelector: priceSelector,
      locale: locale,
      currency: currency,
      showUpperLimit: true,
      amount: amount,
      minMaxThreshold: {
        min: min,
        max: max
      }
    };
    if (Drupal.settings.afterpay_logoColor) {
      apConfig['afterpayLogoColor'] = Drupal.settings.afterpay_logoColor;
    }
    new presentAfterpay(apConfig).init();
  };
  if ($('.js-sku-price').length) {
    amount = $('.js-sku-price').html().replace('$', '').replace('.', '');
  }
  if (amount !== null) {
    presentAfterpay.afterpayConfig(amount);
  }
});
